import React, { useState } from 'react';
import { Header } from './components/Header';
import { Dashboard } from './pages/Dashboard';
import { RunbookExecution } from './pages/RunbookExecution';
import { ManagerReview } from './pages/ManagerReview';
import { ReportSummary } from './pages/ReportSummary';
export function App() {
  const [currentScreen, setCurrentScreen] = useState('dashboard');
  const [runbookType, setRunbookType] = useState('');
  const startRunbook = (type: string) => {
    setRunbookType(type);
    setCurrentScreen('runbook');
  };
  const completeRunbook = () => {
    setCurrentScreen('review');
  };
  const approveRunbook = () => {
    setCurrentScreen('report');
  };
  const returnToDashboard = () => {
    setCurrentScreen('dashboard');
  };
  return <div className="flex flex-col min-h-screen bg-gray-50" data-id="element-0">
      <Header currentScreen={currentScreen} returnToDashboard={returnToDashboard} data-id="element-1" />
      <main className="flex-1 max-w-md mx-auto w-full pb-20" data-id="element-2">
        {currentScreen === 'dashboard' && <Dashboard onStartRunbook={startRunbook} data-id="element-3" />}
        {currentScreen === 'runbook' && <RunbookExecution type={runbookType} onComplete={completeRunbook} data-id="element-4" />}
        {currentScreen === 'review' && <ManagerReview type={runbookType} onApprove={approveRunbook} onBack={() => setCurrentScreen('runbook')} data-id="element-5" />}
        {currentScreen === 'report' && <ReportSummary type={runbookType} onFinish={returnToDashboard} data-id="element-6" />}
      </main>
    </div>;
}